import { AnalyticsService } from './../../../shared/services/analytics/analytics.service';
import { PathUrlEnum } from './../../../utils/analytics.utils';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DataPersonalSellerPf } from '../../../shared/models/SellerPf.model';
import { ErrorMessage } from '../../../shared/models/error-message';
import {
  documents,
  interdito,
  nationalities,
  orgaoExpedidorCnh,
  orgaoExpedidorRg,
  orgaoExpedidorRne,
  sexo,
  states,
} from '../../../utils/constants.utils';
import {
  validatorCNPJ,
  validatorCPF,
} from '../../../utils/validators';
import PatternsUtils from '../../../utils/patterns.utils';
import { mapFormToDataPersonalSellerPfTwo } from '../../../utils/seller-pf-mapper.util';
import { patchFormWithNestedObject } from '../../../utils/seller-mapper.utils';
import CpfHelper from '../../../helpers/cpf.helper';
import { ICityResponse } from '../../../shared/interfaces/ICepResponse';
import { CepService } from '../../../shared/services/cep/cep.service';
import { StatusService } from '../../../shared/services/authentication/status.service';

import {
  addNameSanitizers,
  emailValidator,
  textMinCharsValidator,
  textNoSpecialCharsValidator,
} from '../../../helpers/validate-form.helper';
import { phoneMask } from '../../../utils/masks.utils';
import { birthDateValidator } from '../../../helpers/birth-date.helper';

@Component({
  selector: 'app-seller-step-two-pf',
  templateUrl: './seller-step-two-pf.component.html',
  styleUrls: ['./seller-step-two-pf.component.scss'],
})
export class SellerStepTwoPfComponent implements OnInit {
  @Output() formsComplete = new EventEmitter();
  @Output() dataForms = new EventEmitter();
  @Input() dataPersonal = new DataPersonalSellerPf();
  formStepTwo: FormGroup;
  isFormValid = false;
  isLoading = true;
  listStates = states;
  listCities: ICityResponse[] = [];
  loadingCities = false;
  listaOrgaoExpedidor: { optLabel: string; optValue: string }[] = [];
  listaDocumentos = [...documents];
  listaSexo = sexo;
  listaEspolio = interdito;
  listNacionalites = nationalities;
  docNumMinLen = 8;
  docNumMaxLen = 8;

  phoneMask = phoneMask;

  maskCpfCnpj = CpfHelper.maskCpfCnpj;

  constructor(
    private analyticsService: AnalyticsService,
    private cepService: CepService,
    private statusService: StatusService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getFormData(this.formStepTwo, this.dataPersonal);
    this.isFormComplete();
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PF_DADOS_CONJUGE);
  }

  getErrorMandatory(label: string): string {
    return ErrorMessage.getTextMandatory(label);
  }

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  getEmailFieldError(controlName: string, label: string): string {
    const control = this.formStepTwo.get(controlName);
    return ErrorMessage.getEmailFieldError(control, label);
  }

  getForgotFill(label: string): string {
    return ErrorMessage.forgotFill(label);
  }
  validatedate(control: FormControl): { [key: string]: any } | null {
    return birthDateValidator(control.value);
  }
  getDateFieldError(controlName: string, label: string): string {
    const control = this.formStepTwo.get(controlName);
    return ErrorMessage.getBirthDateFieldError(control, label);
  }

  getTextFieldError(controlName: string, label: string): string {
    const control = this.formStepTwo.get(controlName);
    return ErrorMessage.getTextFieldError(control, label);
  }

  normalizeEmail(controlName: string): void {
  const control = this.formStepTwo.get(controlName);
  if (!control) return;

  const value = (control.value || '').toString().trim().toLowerCase();

  if (value !== control.value) {
    control.setValue(value);
  }
}

  initForm() {
    this.formStepTwo = new FormGroup({
      partner_name: new FormControl('', [
        Validators.required,
        textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]),
      partner_cpf: new FormControl('', [
        Validators.required,
        Validators.maxLength(11),
        Validators.pattern(PatternsUtils.CPF_MAX_14_CHARS),
        validatorCPF,
      ]),
      partner_birth_date: new FormControl('', [
        Validators.required,
        birthDateValidator
      ]),
      partner_birth_state: new FormControl('', [Validators.required]),
      partner_birth_city: new FormControl('', [
        Validators.required,
        Validators.pattern(PatternsUtils.ONLY_LETTERS_WITH_HYPHEN),
      ]),
      partner_gender: new FormControl('', [Validators.required]),
      partner_birth_nationality: new FormControl('', [Validators.required]),
      partner_profession: new FormControl('', [Validators.required]),

      partner_parentage_motherName: new FormControl('', [
        Validators.required,
         textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]),
      partner_parentage_fatherName: new FormControl('', [
        textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]),

      partner_contact_email: new FormControl('', [
        Validators.required,
        emailValidator
      ]),
      partner_contact_phone: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
      ]),

      partner_document_type: new FormControl('', [Validators.required]),
      partner_document_number: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8),
        Validators.pattern(PatternsUtils.ONLY_NUMBER_AND_LETTERS),
      ]),
      partner_document_issueDate: new FormControl('', [
        Validators.required,
        birthDateValidator
      ]),
      partner_document_issuingAuthority: new FormControl('', [
        Validators.required,
      ]),
      partner_document_issuingAuthorityState: new FormControl('', [
        Validators.required,
      ]),

      partner_address_zipCode: new FormControl('', [Validators.required, Validators.minLength(8),
          ]),
      partner_address_state: new FormControl('', [Validators.required]),
      partner_address_city: new FormControl('', [Validators.required]),
      partner_address_district: new FormControl('', [Validators.required]),
      partner_address_street: new FormControl('', [Validators.required]),
      partner_address_number: new FormControl(''),
      partner_address_complement: new FormControl(''),

      partner_deliveryAddress_isLocale: new FormControl(null, [
        Validators.required,
      ]),
      partner_deliveryAddress_zipCode: new FormControl(''),
      partner_deliveryAddress_state: new FormControl(''),
      partner_deliveryAddress_city: new FormControl(''),
      partner_deliveryAddress_district: new FormControl(''),
      partner_deliveryAddress_street: new FormControl(''),
      partner_deliveryAddress_number: new FormControl(''),
      partner_deliveryAddress_complement: new FormControl(''),

      partner_attorneyData_useAttorney: new FormControl(null, [
        Validators.required,
      ]),
      partner_attorneyData_fullName: new FormControl(''),
      partner_attorneyData_phone: new FormControl(''),
      partner_attorneyData_documentNumber: new FormControl(''),
      partner_attorneyData_email: new FormControl(''),

      partner_additionalInformation_hasEmployee: new FormControl('', [
        Validators.required,
      ]),
      partner_additionalInformation_isSellingToFamily: new FormControl('', [
        Validators.required,
      ]),
      partner_additionalInformation_isUnderAge: new FormControl('', [
        Validators.required,
      ]),
      partner_additionalInformation_situation: new FormControl(''),
    });

    this.formStepTwo.controls.partner_parentage_fatherName.valueChanges.subscribe(
      {
        next: (sellerSpouseFathersName) => {
          if (
            sellerSpouseFathersName?.trim() ===
            this.formStepTwo.get('partner_parentage_motherName')?.value?.trim()
          ) {
            this.formStepTwo.controls.partner_parentage_fatherName.setErrors({
              invalid: 'Mesmo nome da mãe.',
            });
          }
        },
      }
    );

    this.formStepTwo.get('partner_document_type')?.valueChanges.subscribe({
      next: (sellerDocumentType) => {
        this.clearValue('partner_document_number');
        this.clearValue('partner_document_issuingAuthority');

        this.listaOrgaoExpedidor = [];
        this.docNumMinLen = 8;
        this.docNumMaxLen = 8;

        if (sellerDocumentType === 'RG') {
          this.formStepTwo
            .get('partner_document_number')
            ?.setValidators([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(15),
              Validators.pattern(PatternsUtils.ONLY_NUMBER_AND_LETTERS),
            ]);
          this.docNumMinLen = 6;
          this.docNumMaxLen = 15;
          this.listaOrgaoExpedidor = [...orgaoExpedidorRg];
        }

        if (sellerDocumentType === 'RNE') {
          this.formStepTwo
            .get('partner_document_number')
            ?.setValidators([
              Validators.required,
              Validators.minLength(8),
              Validators.maxLength(8),
              Validators.pattern(PatternsUtils.ONLY_NUMBER_AND_LETTERS),
            ]);
          this.docNumMinLen = 8;
          this.docNumMaxLen = 8;
          this.listaOrgaoExpedidor = [...orgaoExpedidorRne];
        }

        if (sellerDocumentType === 'CNH') {
          this.formStepTwo
            .get('partner_document_number')
            ?.setValidators([
              Validators.required,
              Validators.minLength(9),
              Validators.maxLength(11),
              Validators.pattern(PatternsUtils.ONLY_NUMBERS),
            ]);
          this.docNumMinLen = 9;
          this.docNumMaxLen = 11;
          this.listaOrgaoExpedidor = [...orgaoExpedidorCnh];
        }
      },
    });

    this.formStepTwo.get('partner_birth_nationality')?.valueChanges.subscribe({
      next: (sellerNationality) => {
        if (sellerNationality?.toLocaleLowerCase().trim() !== 'brasileira') {
          this.formStepTwo.get('partner_birth_state')?.setValue('');
          this.formStepTwo.get('partner_birth_state')?.disable();
          this.clearValidation('partner_birth_state');
        } else {
          this.formStepTwo.get('partner_birth_state')?.enable();
          this.updateValidators('partner_birth_state', [Validators.required]);
          this.formStepTwo.get('partner_birth_city')?.disable();
        }
      },
    });

    this.formStepTwo.get('partner_birth_state')?.valueChanges.subscribe({
      next: (value) => {
        if (value) {
          this.getCities(value);
          this.formStepTwo.get('partner_birth_city')?.enable();
        } else {
          this.formStepTwo.get('partner_birth_city')?.setValue('');
          if (
            this.formStepTwo
              .get('partner_birth_nationality')
              ?.value?.toLocaleLowerCase() !== 'brasileira'
          ) {
            this.formStepTwo.get('partner_birth_city')?.enable();
          }
        }
      },
    });

    addNameSanitizers(this.formStepTwo, {
      controlNames: ['partner_name','partner_parentage_motherName','partner_parentage_fatherName','partner_attorneyData_fullName'],
    });
  }

  updateValidators(key: string, validators: ValidatorFn[] | null = null) {
    this.formStepTwo.controls[key].setValidators(validators);
    this.formStepTwo.controls[key].updateValueAndValidity();
  }

  get isProxyData(): boolean {
    return (
      !!this.dataPersonal?.partner?.attorneyData &&
      !!this.dataPersonal?.partner.attorneyData?.useAttorney
    );
  }

  getCities(uf: string): void {
    this.loadingCities = true;
    this.cepService.getCities(uf).subscribe({
      next: (response) => {
        this.listCities = response.data;
        if (
          !this.listCities.find(
            (city) =>
              city.name === this.formStepTwo.get('partner_birth_city')?.value
          )
        ) {
          this.formStepTwo
            .get('partner_birth_city')
            ?.setValue(null, { emitEvent: true });
          this.formStepTwo.get('partner_birth_city')?.updateValueAndValidity();
        }
        this.loadingCities = false;
      },
      error: () => {
        this.loadingCities = false;
        this.statusService.showToast(
          'error',
          'desculpe, não conseguimos carregar a lista de cidades'
        );
      },
    });
  }

  procuratorChange(useAttorney: boolean) {
    if (useAttorney) {
      this.updateValidators('partner_attorneyData_fullName', [
        Validators.required,
        textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]);
      this.updateValidators('partner_attorneyData_documentNumber', [
        Validators.required,
        Validators.pattern(PatternsUtils.CNPJ),
        Validators.pattern(PatternsUtils.CPF_MAX_14_CHARS),
      ]);
      this.updateValidators('partner_attorneyData_phone', [
        Validators.required,
        Validators.minLength(10),
      ]);
      this.updateValidators('partner_attorneyData_email', [
        Validators.required,
       emailValidator
      ]);
    } else {
      this.clearValidation('partner_attorneyData_documentNumber');
      this.clearValidation('partner_attorneyData_fullName');
      this.clearValidation('partner_attorneyData_email');
      this.clearValidation('partner_attorneyData_phone');
      this.clearValue('partner_attorneyData_documentNumber');
      this.clearValue('partner_attorneyData_fullName');
      this.clearValue('partner_attorneyData_email');
      this.clearValue('partner_attorneyData_phone');
    }
  }

  assetChange(isAsset: boolean) {
    if (isAsset) {
      this.isRequired('partner_additionalInformation_situation', [
        Validators.required,
      ]);
    } else {
      this.clearValidation('partner_additionalInformation_situation');
    }
  }

  isAssets() {
    return this.dataPersonal.partner?.additionalInformation.isUnderAge;
  }

  postLocationChange(isLocale: boolean) {
    if (isLocale) {
      this.clearValidation('partner_deliveryAddress_zipCode');
      this.clearValidation('partner_deliveryAddress_street');
      this.clearValidation('partner_deliveryAddress_state');
      this.clearValidation('partner_deliveryAddress_number');
      this.clearValidation('partner_deliveryAddress_complement');
      this.clearValidation('partner_deliveryAddress_city');
      this.clearValidation('partner_deliveryAddress_district');
      this.clearValue('partner_deliveryAddress_zipCode');
      this.clearValue('partner_deliveryAddress_street');
      this.clearValue('partner_deliveryAddress_state');
      this.clearValue('partner_deliveryAddress_number');
      this.clearValue('partner_deliveryAddress_complement');
      this.clearValue('partner_deliveryAddress_city');
      this.clearValue('partner_deliveryAddress_district');
    } else {
      this.updateValidators('partner_deliveryAddress_zipCode', [
        Validators.required,
        Validators.minLength(8),
      ]);
      this.updateValidators('partner_deliveryAddress_street', [
        Validators.required,
      ]);
      this.updateValidators('partner_deliveryAddress_state', [
        Validators.required,
      ]);

      this.updateValidators('partner_deliveryAddress_city', [
        Validators.required,
      ]);
      this.updateValidators('partner_deliveryAddress_district', [
        Validators.required,
      ]);
    }
  }

  isOtherLocation() {
    return (
      !!this.dataPersonal.partner?.deliveryAddress &&
      !this.dataPersonal.partner.deliveryAddress?.isLocale
    );
  }

  isRequired(key: string, validators: ValidatorFn[] | null = null) {
    this.formStepTwo.controls[key].setValidators(validators);
    this.formStepTwo.controls[key].updateValueAndValidity();
  }

  clearValidation(key: string) {
    this.formStepTwo.controls[key].setValidators(null);
    this.formStepTwo.controls[key].setErrors(null);
  }

  clearValue(key: string) {
    this.formStepTwo.get(key)?.patchValue('');
  }

  procuratorCpfChange() {
    const validators = [Validators.required];

    if (
      this.formStepTwo.controls.partner_attorneyData_documentNumber?.value
        .length <= 11
    ) {
      validators.push(validatorCPF);
    } else {
      validators.push(validatorCNPJ);
    }

    this.clearValidation('partner_attorneyData_documentNumber');
    this.isRequired('partner_attorneyData_documentNumber', validators);
  }

  getFormData(formGroup: FormGroup, data: DataPersonalSellerPf): void {
    patchFormWithNestedObject(formGroup, data);
  }

  isFormComplete() {
    this.formStepTwo.statusChanges.subscribe((newStatus) => {
      const formValue = this.formStepTwo.getRawValue();
      Object.assign(
        this.dataPersonal,
        mapFormToDataPersonalSellerPfTwo(formValue)
      );
      if (newStatus.toLowerCase() === 'valid') {
        this.formsComplete.emit(true);
        this.dataForms.emit(this.dataPersonal);
      } else {
        this.formsComplete.emit(false);
      }
    });
  }
}
